import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CM',
  name: 'Cristian M.',
  role: '📍 Córdoba',
  quote: 'Toda la vida laburé con las manos, pero nunca me animé a emprender. Este manual me cambió la cabeza. Armé mis primeros muebles y ya tengo tres encargos del barrio. Es una locura lo que aprendí en pocos días.'
}, {
  initials: 'MM',
  name: 'Marcelo M.',
  role: '📍 Buenos Aires',
  quote: 'No tenía idea ni de cómo agarrar una soldadora, y hoy estoy haciendo estructuras para mesas y bancos. Está todo explicado paso a paso, sin vueltas. Es como tener un profe al lado.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  role: '📍 Mendoza',
  quote: 'Mi viejo era carpintero y yo siempre lo miraba de chica. Con este curso pude animarme y seguir su camino. El contenido está buenísimo y te da una motivación tremenda para arrancar.'
}, {
  initials: 'DS',
  name: 'Diego S.',
  role: '📍 Santa Fe',
  quote: 'Lo compré con dudas, pero posta… vale cada peso. Me ayudó a organizar el taller, mejorar mis terminaciones y encima aprendí a vender. Lo poco que vale con lo que aporta no tiene sentido.'
}, {
  initials: 'FR',
  name: 'Fabián R.',
  role: '📍 Entre Ríos',
  quote: 'Lo mejor es que no necesitás herramientas caras para empezar. Seguí las guías, hice mis primeros muebles y los vendí por Facebook. No lo podía creer.'
}, {
  initials: 'NG',
  name: 'Natalia G.',
  role: '📍 Rosario',
  quote: 'Me cambió la forma de ver el trabajo. Antes hacía changas, no juntaba nada de guita, ahora tengo mi propio emprendimiento. El manual es claro, motivador y te da resultados reales.'
}];
export function FullTestimonials() {
  return <section className="py-20 px-4 bg-white" data-id="element-161">
      <div className="max-w-4xl mx-auto" data-id="element-162">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-16" data-id="element-163">
          Lo que dicen los que <br className="hidden md:block" data-id="element-164" />
          <span className="text-brand-rust" data-id="element-165">ya empezaron:</span>
        </h2>

        <div className="space-y-8" data-id="element-166">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-gray p-8 rounded-2xl shadow-md border border-gray-200" data-id="element-167">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-168">
                <div className="flex-shrink-0 flex flex-col items-center" data-id="element-169">
                  <div className="w-16 h-16 bg-brand-steel text-white rounded-full flex items-center justify-center text-xl font-bold mb-3" data-id="element-170">
                    {t.initials}
                  </div>
                  <div className="flex text-brand-forge" data-id="element-171">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-172" />)}
                  </div>
                </div>
                <div data-id="element-173">
                  <h4 className="text-xl font-bold text-brand-dark mb-1" data-id="element-174">
                    {t.name}
                  </h4>
                  <p className="text-sm text-gray-500 font-medium mb-4" data-id="element-175">
                    {t.role}
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed italic" data-id="element-176">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}